import { ColumnDef } from '@tanstack/react-table';
import { AutoAwesome } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { formatToDate } from '../../utils/formatting';
import { AvgScoreCell } from '@/components/common';

import type { Campaign } from './types';

const campaignListColumns: ColumnDef<Campaign>[] = [
    {
        accessorKey: 'has_questions',
        header: 'Insights',
        cell: ({ getValue }) => {
            const hasQuestions = getValue() as boolean;
            const title = hasQuestions ? 'This project has Insights questions' : 'This project has no Insights questions';
            const color = hasQuestions ? 'primary' : 'disabled';

            return (
                <Box sx={{ display: 'flex', width: '48px', justifyContent: 'center' }}>
                    <Tooltip title={title} arrow>
                        <AutoAwesome fontSize="small" color={color} />
                    </Tooltip>
                </Box>
            );
        },
        enableSorting: true,
        size: 65,
    },
    {
        accessorKey: 'name',
        header: 'Name',
        enableSorting: true,
        cell: ({ getValue }) => getValue() || '',
    },
    {
        accessorKey: 'desc',
        header: 'Description',
        cell: ({ getValue }) => getValue() || '',
        enableSorting: true,
    },

    {
        accessorKey: 'agent_count',
        header: 'Agents',
        cell: ({ getValue }) => getValue() || 0,
        enableSorting: true,
        size: 90,
    },
    {
        accessorKey: 'avg_score',
        header: 'Avg Score',
        enableSorting: true,
        cell: ({ getValue }) => <AvgScoreCell score={getValue() as number | null} />,
        size: 100,
    },
    {
        accessorKey: 'office',
        header: 'Office',
        cell: ({ getValue }) => getValue() || '',
        enableSorting: true,
    },
    {
        accessorKey: 'created_at',
        header: 'Time created',
        cell: ({ getValue }) => {
            const createdAt = getValue() as string | null;
            return createdAt ? formatToDate(createdAt) : '';
        },
        enableSorting: true,
    },
];

export default campaignListColumns;
